import { render, staticRenderFns } from "./farmersUser.vue?vue&type=template&id=5703660e&scoped=true"
import script from "./farmersUser.vue?vue&type=script&lang=js"
export * from "./farmersUser.vue?vue&type=script&lang=js"
import style0 from "./farmersUser.vue?vue&type=style&index=0&id=5703660e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5703660e",
  null
  
)

export default component.exports